// extracted by css-extract-rspack-plugin
export default {"container":"_e4ce9f45"};